// extracted by mini-css-extract-plugin
export default {"row":"_2b6b0a2d87004e29"};